export default function (zeigeVGV = true, zeigeVHV = true) {
  const leistungen = [
    {
      leistungstext: "Grobe Fahrlässigkeit",
      infoText:
        "Es findet keine Kürzung der Leistung aufgrund grober Fahrlässigkeit statt. Dies kann bis zu einer bestimmten Schadenhöhe festgelegt sein. Lassen Sie beispielsweise eine Kerze brennen und das Haus brennt daraufhin ab, würden wir den Schaden dennoch übernehmen.",
      leistungen: ["Ja"],
    },
    {
      leistungstext: "Ersatzunterkunft bis zu 100 Tagen",
      infoText:
        "Ist die Wohnung/Immobilie in Folge eines Versicherungsfalles nicht bewohnbar ersetzen wir die angemessenen Kosten für eine Ersatzunterkunft. Dies gilt für den Versicherungsnehmer als auch für die Mieter der Ferienimmobilie begrenzt auf den Mietzeitraum.",
      leistungen: ["Max. 10.000 €"],
    },
    {
      leistungstext: "Mehrkosten durch Rückreise",
      infoText:
        "Wir ersetzen angemessene Fahrtmehrkosten des Versicherungsnehmers bei dessen vorzeitiger Rückreise zu seinem gewöhnlichen Wohnort in dem Fall, dass die Ferienimmobilie in Folge eines Versicherungsfalles nicht mehr genutzt werden kann.",
      leistungen: ["Max. 10.000 €"],
    },
    {
      leistungstext: "Reisekosten zum Schadenort",
      infoText:
        "Wir übernehmen die Kosten für eine Anreise zur Ferienimmobilie auf Grund eines versicherten Schadenfalles. Dies gilt ab einer Schadenhöhe von 5.000 €.",
      leistungen: ["Max. 10.000 €"],
    },
  ];
  if (zeigeVGV) {
    leistungen.push(
      {
        leistungstext: "Ableitungsrohre bis 10.000 € (bis 20.000 EUR bei Dichtheitsprüfung)",
        infoText:
          "Kostenübernahme für Frost- und sonstige Bruchschäden an Ableitungsrohren der Wasserversorgung außerhalb des Gebäudes, auch wenn diese außerhalb des versicherten Grundstückes verlaufen sofern das beschädigte Rohr der Wasserentsorgung des Gebäudes dient.",
        leistungen: ["Bis 10.000 €"],
      },
      {
        leistungstext: "Umgestürzte und abgeknickte Bäume",
        infoText:
          "Kosten für das Aufräumen und Entfernen von Bäumen, die durch Sturm oder Blitzeinschlag abgeknickt bzw. umgestürzt sind.",
        leistungen: ["Bis 10.000 €"],
      },
      {
        leistungstext: "Mietausfall für die Ferienimmobilie",
        infoText:
          "Wir ersetzen den Mietausfall für nachweislich schon vor Schadeneintritt bestätigte Buchungen der Immobilie.",
        leistungen: ["Bis 25.000 €"],
      },
      {
        leistungstext: "Leckortungskosten",
        infoText: "Wir ersetzen die Leckortungskosten bei nichtversicherten Schäden bis 500 €.",
        leistungen: ["Bis 500 €"],
      },
    );
  }

  if (zeigeVHV || zeigeVGV) {
    leistungen.push({
      leistungstext: "Fehlalarm von Rauch- oder Gasmelder",
      infoText:
        "Wir übernehmen die Kosten welche in Folge eines Fehlalarmes entstehen. Hierunter fallen z.B. Kosten für eintreffende Feuerwehr",
      leistungen: ["Max. 5.000 €"],
    });
  }

  if (zeigeVHV) {
    leistungen.push({
      leistungstext: "Wertsachen sind mit 40% der Versicherungssumme versichert",
      infoText: "",
      leistungen: [
        "40% der Versicherungssumme, davon maximal: 1.000 € Bargeld, 5.000 € Schmuck, 10.000 € Kunstgegenstände",
      ],
    });
  }
  if (!zeigeVGV && zeigeVHV) {
    leistungen.push({
      leistungstext: "Mitversicherung privat genutzter Antennen, Markisen und Balkonkraftwerke (Steckersolaranlagen)",
      infoText: "",
      leistungen: ["Ja"],
    });
  } else {
    leistungen.push({
      leistungstext: "Mitversicherung Markisen und Überdachungen ",
      infoText: "",
      leistungen: ["Ja"],
    });
  }
  return leistungen;
}
